// Platform detection, resolved once at module load (the OS never changes mid
// session). Used to render the per-platform Dashboard shortcut hint: Cmd on
// Mac, Ctrl on Windows/Linux.

const detectMac = () => {
  if (typeof navigator === "undefined") return false;
  const platform =
    navigator.userAgentData?.platform || navigator.platform || "";
  if (/mac/i.test(platform)) return true;
  // Some browsers leave platform empty; fall back to the user-agent string.
  return /mac/i.test(navigator.userAgent || "");
};

export const isMac = detectMac();

// The command-modifier glyph for the shortcut hint. The Mac command symbol is a
// normal Unicode glyph, not a dash.
export const commandKeyLabel = isMac ? "⌘" : "Ctrl";
